import { BUYABLE_FEE_POLICY } from '@fiverr-private/price_upfront_components';

type FeePolicyTranslationKey = 'fees' | 'fees_exempt_tax' | 'fees_with_tax';
export const POLICY_TO_KEY: Record<
    (typeof BUYABLE_FEE_POLICY)[keyof typeof BUYABLE_FEE_POLICY],
    FeePolicyTranslationKey
> = {
    [BUYABLE_FEE_POLICY.FEES]: 'fees',
    [BUYABLE_FEE_POLICY.FEES_WITHOUT_TAX]: 'fees_exempt_tax',
    [BUYABLE_FEE_POLICY.FEES_AND_TAX]: 'fees_with_tax',
};
